<div class="row justify-content-between justify-content-md-start">
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Ad Viewability"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.viewabilityDistribution?.nonGivtSivtViewability | perc:'1.2-2'}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="CTR (Click Through Rate)" key="CTR"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.ctrDistribution?.ctr | perc:'1.2-2'}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Ads per Page"></info-tooltip2>
      <img class="beta-tag ml-1" src="/assets/images/beta-tag.png" alt="Beta Tag" />
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.mfa?.noOfAdsPerMin}}
    </h3>
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Ad View Time"></info-tooltip2>
      <img class="beta-tag ml-1" src="/assets/images/beta-tag.png" alt="Beta Tag" />
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.avgAdExposureTime | duration: 'ms':'mmss'}}
    </h3>
  </div>
</div>